
import React, { Component}  from 'react';
import { DetailProvider, DetailContext } from 'core/DetailProvider';

import Layout  from 'components/Dashboard/Layout';

import { StyledClientDetailOrders } from './Styled';
import ClientDetailHeader from "./DetailHeader";
import ChangesList from 'components/Changes/List';


export default class ClientDetailChanges extends Component {

  render() {
    const { match, history } = this.props;
    return (
      <DetailProvider
        url={`client/${match.params.id}`}
      >
        <DetailContext.Consumer>
          {context => {
            let { item } = context;

            return (
              <Layout>
                <StyledClientDetailOrders>
                  <div>
                    <ClientDetailHeader item={item} history={history} match={match} />

                    <Layout.ContentSimple>
                      <ChangesList item={item} />
                    </Layout.ContentSimple>
                  </div>
                </StyledClientDetailOrders>
              </Layout>
            )
          }}
        </DetailContext.Consumer>
      </DetailProvider>
    )
  }
}
